<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn
        :menuid="menuid"
        @btnClick="btnClick"
        :btnLoading="btnLoading"
      ></menu-btn>
    </div> -->
    <div>
      <el-tabs v-model="activeName" type="card" >
        <el-tab-pane label="待结算" name="first">
          <settlementXMYTab :activeName="activeName" />
        </el-tab-pane>
        <el-tab-pane label="项目结算未达" name="second">
          <xmyNotReached :activeName="activeName"/>
        </el-tab-pane>
        <el-tab-pane label="已结算" name="third">
          <settledXMYTab :activeName="activeName" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import MenuBtn from "../common/menuBtn";
import settlementXMYTab from "./settlementXMYTab";
import settledXMYTab from "./settledXMYTab";
import xmyNotReached from "./xmyNotReached";
export default {
  name: "ywyjx",
  data() {
    return {
      menuid: this.$route.query.menuid,
      btnLoading: false,
      activeName: "first",
      list: [],
    };
  },
  activated() {},
  components: { MenuBtn, settlementXMYTab, settledXMYTab,xmyNotReached},
  created() {
    this.$on("CLOSE", () => this.close());
  },
  mounted() {},
  watch: {},
  filters: {},
  methods: {
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "",
      });
    },
    btnClick(code) {
      this.$emit(code);
    },
  },
};
</script>

<style scoped>
</style>
